import { getAppId } from 'src/core/classes/helpers/getAppId'
import { proxySiteBuilder } from 'src/core/classes/helpers/UrlHelper'
import { Rest } from 'src/core/classes/http'
import { IDropdownLOV } from 'src/core/classes/models/IDropdownLOV'
import { IProcedureFetcherSpec } from 'src/core/types'

export const dropdownLovFetcher: IProcedureFetcherSpec<IDropdownLOV>['readFromTo'] = async (
  filter,
  sort,
  paging
) => {
  const url = proxySiteBuilder('/mbe/api/v1/dropdown-lov/search')
  const response = await Rest.post({ url, payload: { filter, sort, paging }, identityToken: true })

  if (response.status !== 'success') {
    return { Data: [], Errors: response.message }
  }

  return { Data: response.data, Total: response.meta.total, Errors: '' }
}

export const updateDropdownLov: IProcedureFetcherSpec<IDropdownLOV>['updateHandler'] = async ({
  models,
}) => {
  const url = proxySiteBuilder('/mbe/api/v1/dropdown-lov')

  const response = await Rest.put({ url, payload: { models }, identityToken: true })

  if (response.status !== 'success') {
    return [] as IDropdownLOV[]
  }

  return response.data
}

export const createDropdownLov: IProcedureFetcherSpec<IDropdownLOV>['createHandler'] = async ({
  models,
}) => {
  const url = proxySiteBuilder('/mbe/api/v1/dropdown-lov')

  const preparedModels = models.map((el) => {
    return { ...el, AppId: getAppId() }
  })

  const response = await Rest.post({
    url,
    payload: { models: preparedModels },
    identityToken: true,
  })

  if (response.status !== 'success') {
    return []
  }

  return response.data
}

export const deleteDropdownLov: IProcedureFetcherSpec<IDropdownLOV>['deleteHandler'] = async ({
  uids,
}) => {
  const url = proxySiteBuilder('/mbe/api/v1/dropdown-lov')

  const response = await Rest.delete({ url, payload: { uids }, identityToken: true })

  return response.status === 'success'
}
